// Flights move ~250 m/s — far faster than buses/ferries — and report ~every 8s.
// Rather than gliding A→B (one poll behind), we dead-reckon each aircraft forward
// from its last fix using heading + ground speed, and ease the rendered marker
// onto each new fix so corrections never rubber-band.

/** Server poll cadence for the flights feed (ms). */
export const FLIGHT_POLL_MS = 8_000;
/** Duration over which a fresh poll's correction eases onto the marker (ms). */
export const FLIGHT_EASE_MS = 1_200;
/** Stop projecting forward once a fix is older than this (ms) — feed gap guard. */
export const FLIGHT_MAX_EXTRAP_MS = 20_000;
/** Below this ground speed (knots) treat as hovering: hold position, keep heading. */
export const FLIGHT_HOVER_GS_KT = 5;
/** Corrections larger than this (m) teleport instead of easing (data gap / reacquire). */
export const FLIGHT_SNAP_METERS = 10_000;
/** Knots → metres per second. */
export const KNOTS_TO_MPS = 0.514444;
